module.exports = __webpack_public_path__ + "img/tienda-3.01694409.png";